export default "__VITE_PUBLIC_ASSET__c36de3c8__"